export default {
    reviewOrder: {
        reviewOrder: "查看订单"
    }
}